import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";

export const sentimentSatisfied = (props) => {
  return <SentimentSatisfiedIcon {...props} />;
};
